import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import OpenSlideShow from '../components/OpenSlideShow'
import NiroSection from '../components/NiroSection'
import ProductBento from '../components/ProductBento'
import CollabProcessSection from '../components/CollabProcessSection'
import TestimonialSection from '../components/TestimonialSection'
import LatestNewsSection from '../components/LatestNewsSection'
import Footer from '../components/Footer'

import '../css/MainPage.css';

/*
 * Home page order (Sep 2026 restructure):
 *   hero (field footage) -> NIRO, the brain in every Nexuni robot ->
 *   product bento (odo series / welding / parking / video security) ->
 *   how we work -> client stories -> latest news -> footer.
 * Every section sits on ink; there is no light band anywhere.
 */
class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang
    }

    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    updateSEO('home', this.state.lang, '/');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
      updateSEO('home', nextProps.lang, '/');
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    const lang = this.state.lang;
    return (
      <div className={lang + " main_page"}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <OpenSlideShow lang={lang} navigate={this.navigate} />
        <NiroSection lang={lang} navigate={this.navigate} />
        <ProductBento lang={lang} navigate={this.navigate} />
        <CollabProcessSection lang={lang} navigate={this.navigate} />
        <TestimonialSection lang={lang} navigate={this.navigate} />
        <LatestNewsSection lang={lang} navigate={this.navigate} />
        <Footer lang={lang} navigate={this.navigate} />
      </div>
    )
  }

}

export default MainPage;
